
export const cleanHtml = (text: string) => {
  let cleaned = text.trim();
  
  // Remove <thought>...</thought>
  cleaned = cleaned.replace(/<thought>[\s\S]*?<\/thought>/g, '');
  
  // Remove metadata markers (case-insensitive)
  cleaned = cleaned.replace(/\[PROJECT ARCHITECTURE INITIALIZED\]/gi, '');
  
  // Remove specific preamble markers
  cleaned = cleaned.replace(/Yacht Labs Synthesis Engine:?/gi, '');
  cleaned = cleaned.replace(/Synthesizing architecture.../gi, '');
  cleaned = cleaned.replace(/Synthesizing build.../gi, '');

  // Handle cases where the content is wrapped in triple backticks
  if (cleaned.startsWith('```')) {
    const lines = cleaned.split('\n');
    if (lines[0].startsWith('```')) lines.shift();
    if (lines[lines.length - 1].startsWith('```')) lines.pop();
    cleaned = lines.join('\n').trim();
  }
  
  // Catch any stray backticks at end
  if (cleaned.endsWith('```')) {
    cleaned = cleaned.substring(0, cleaned.length - 3).trim();
  }
  
  return cleaned;
};

export const parseFiles = (text: string) => {
  const files: Record<string, string> = {};
  
  // Split by [FILE: name]
  const pattern = /\[\s*FILE:\s*(.*?)\s*\]/gi;
  let match;
  let matches = [];

  while ((match = pattern.exec(text)) !== null) {
      matches.push({
          name: match[1].trim(),
          startIndex: match.index,
          contentStartIndex: pattern.lastIndex
      });
  }

  if (matches.length === 0) {
      // If no [FILE:] markers, check for markdown code block as a whole
      files['index.html'] = cleanHtml(text);
  } else {
      for (let i = 0; i < matches.length; i++) {
          const current = matches[i];
          const next = matches[i + 1];
          const nextStartIndex = next ? next.startIndex : text.length;
          const rawContent = text.substring(current.contentStartIndex, nextStartIndex);
          files[current.name] = cleanHtml(rawContent);
      }
  }

  return files;
};
